import { GetServerSideProps } from 'next';

import createApolloClient from 'src/modules/ApolloWrapper/createApolloClient';
import {
  GetHierarchicalJobCategoriesWithActiveJobsData,
  queryHierarchicalJobCategoriesWithActiveJobs,
} from 'src/modules/Seo/graphql';
import JobsByJobCategoryPage from 'src/modules/Seo/JobsByJobCategoryPage';

export default JobsByJobCategoryPage;

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { req, res, resolvedUrl } = context;

  res.setHeader(
    'Cache-Control',
    'public, s-maxage=3600, stale-while-revalidate=3599'
  );

  const isPaginationURL = resolvedUrl?.includes('?page=');

  if (isPaginationURL) {
    return {
      redirect: {
        destination: resolvedUrl.replace(/\?page=\d+/, ''),
        permanent: true,
      },
    };
  }

  const { dstContext } = req;
  const { clientConfig } = dstContext;
  const { COUNTRY: country } = clientConfig;

  const apolloClient = createApolloClient({
    listenPort: dstContext.listenPort,
    token: dstContext.accessToken,
    cookie: req.headers.cookie,
    ssrToken: dstContext.ssrToken,
    remoteAddress: dstContext.remoteAddress,
    xForwardedFor: req.headers['x-forwarded-for'],
    locale: clientConfig?.LANG,
    country: clientConfig?.COUNTRY,
  });

  let initialJobCategoriesData = null;
  try {
    const { data: jobCategoriesWithActiveJobsData } =
      await apolloClient.query<GetHierarchicalJobCategoriesWithActiveJobsData>({
        query: queryHierarchicalJobCategoriesWithActiveJobs,
        variables: {
          countryCode: country,
          shouldGetAllData: true,
        },
      });
    initialJobCategoriesData = jobCategoriesWithActiveJobsData;
  } catch (error) {
    console.error('Error fetching districts', error);
  }

  return {
    props: {
      initialJobCategoriesData,
    },
  };
};
